<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsBiz-ftyInvInNotice',
  components: { PageTable },
}
</script>
